import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';

export default function AuthScreen({ onAuth }) {
  const [view, setView] = useState('login');

  return (
    <div className="w-full h-full relative overflow-hidden flex flex-col" style={{ background: 'linear-gradient(160deg, #f5ede8 0%, #fdf6ec 60%, #ede8f5 100%)' }}>
      {/* Background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-[-15%] left-[-20%] w-[70%] h-[50%] rounded-full bg-[#d1ece5] blur-3xl opacity-50" />
        <div className="absolute top-[30%] right-[-25%] w-[65%] h-[55%] rounded-full bg-[#e6e0f8] blur-3xl opacity-50" />
        <div className="absolute bottom-[-15%] left-[5%] w-[80%] h-[50%] rounded-full bg-[#ffe0d2] blur-3xl opacity-40" />
      </div>

      {/* Logo area */}
      <div className="relative z-10 flex flex-col items-center pt-16 pb-6 flex-shrink-0">
        <img
          src="https://media-manager-c.questera.ai/greta-media/1593c15ad88356866a2eabcebc8aef2c67d9fc5afee8d56439ced245a0c6c3417efffbd95aedd1b6f68107af9f17a1fd/images/aW1hZ2UvcG5n/44d2d46ca6ce6a8943aba646038b0408.png"
          alt="Glowlytix"
          className="w-16 h-16 object-contain drop-shadow-md mb-3"
        />
        <h1 className="font-serif text-4xl text-stone-900 leading-none">Glowlytix</h1>
        <p className="font-sans text-sm text-stone-400 mt-2 tracking-wide">Reverse engineer your best skin</p>
      </div>

      {/* Form area */}
      <div className="relative z-10 flex-1 overflow-y-auto px-5 pb-10">
        <AnimatePresence mode="wait">
          {view === 'login' && (
            <motion.div key="login" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.25 }}>
              <LoginForm onAuth={onAuth} onSignUp={() => setView('signup')} onForgot={() => setView('forgot')} />
            </motion.div>
          )}
          {view === 'signup' && (
            <motion.div key="signup" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.25 }}>
              <SignUpForm onAuth={onAuth} onLogin={() => setView('login')} />
            </motion.div>
          )}
          {view === 'forgot' && (
            <motion.div key="forgot" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.25 }}>
              <ForgotPasswordForm onBack={() => setView('login')} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}